import React from 'react';
import { useSite } from '../context/SiteContext';

const BrandsMarquee = () => {
  const { brandLogos = [] } = useSite();
  const items = [...brandLogos, ...brandLogos];
  return (
    <section id="partners" className="relative border-y border-white/5 bg-white/[0.02] py-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between mb-6">
          <p className="text-xs uppercase tracking-[0.24em] text-slate-400">
            Trusted brand partners
          </p>
          <span className="text-xs text-slate-500">Global · Certified · Reliable</span>
        </div>
        <div className="overflow-hidden relative">
          <div
            className="pointer-events-none absolute inset-y-0 left-0 w-24 z-10"
            style={{ background: 'linear-gradient(to right, #06080d, transparent)' }}
          />
          <div
            className="pointer-events-none absolute inset-y-0 right-0 w-24 z-10"
            style={{ background: 'linear-gradient(to left, #06080d, transparent)' }}
          />
          <div className="flex gap-14 animate-marquee w-max">
            {items.map((b, i) => (
              <div
                key={`${b.name}-${i}`}
                className="flex items-center justify-center h-14 min-w-[140px] opacity-60 hover:opacity-100 btn-transition"
                title={b.name}
              >
                <img
                  src={b.src}
                  alt={b.name}
                  className="max-h-10 w-auto object-contain"
                  style={{ filter: 'grayscale(100%) brightness(1.6)' }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandsMarquee;
